"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let ContractServiceFee = class ContractServiceFee extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    getServiceDescription(...args) {
        const [data] = args;
        const result = [];
        if (data.contract) {
            result.push(data.contract.contract_number);
        }
        if (data.contract_service) {
            result.push(data.contract_service.name);
        }
        if (result.length) {
            return result.join(" / ");
        }
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    resource;
    onResource(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("resource");
    }
    noHeader;
    onNo_header(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("noHeader");
    }
    noFooter;
    onNo_footer(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("noFooter");
    }
    displayParent;
    onDisplay_parent(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("displayParent");
    }
    inlineCommands;
    onInline_commands(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("inlineCommands");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    formName;
    item;
    async $$load_item() {
        return this.oid ? this.$fn.fetch('read_contract_service_fee', { parameters: { id: this.oid } }) : this.resource;
    }
    serviceDescription;
    async $$load_serviceDescription() {
        return this.getServiceDescription(this.item);
    }
    labelAlign;
    billingCategories;
    async $$load_billingCategories() {
        return this.$fn.fetch('get_tags', { parameters: { tag_type: 'billing_category' } });
    }
    messages;
    currencies;
    async $$load_currencies() {
        return this.$fn.fetch('list_currency');
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['formId', 'formName', 'item', 'serviceDescription', 'labelAlign', 'billingCategories', 'messages', 'currencies', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                formName: "ContractServiceFee",
                item: null,
                serviceDescription: null,
                labelAlign: "right",
                billingCategories: null,
                messages: {
                    addService: {
                        title: this.$fn.pgettext("Contract", "Add Service"),
                    },
                    editService: {
                        title: this.$fn.pgettext("Contract", "Edit Service"),
                    },
                    addServiceFee: {
                        title: this.$fn.pgettext("Contract", "Add Service Fee"),
                    },
                    editServiceFee: {
                        title: this.$fn.pgettext("Contract", "Edit Service Fee"),
                    },
                },
                currencies: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    noPrimaryButton: true,
                    closeButtonText: this.$fn.gettext("Close"),
                    size: "lg",
                },
            },
        };
    }
    get isReadonly() {
        if (this.loaded) {
            return this.item && this.item.isReadonly;
        }
        return null;
    }
    get document() {
        if (this.loaded) {
            return {
                title: [this.serviceDescription,
                    this.$fn.pgettext("ContractServiceFee", "fee"),
                ],
                icon: this.$config.contract.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3710_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_3716_getActionArgs($event) {
        return {
            result: {
                ok: true,
                value: $event.data,
            },
        };
    }
    async evh_1040167445267876_success_3715_getWhen($event) {
        return this.modal;
    }
    async act_1040167445267876_crud_3714_getActionArgs($event) {
        return {
            objectType: "contract_service_fee",
            op: "upsert",
            data: this.item,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3710 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3710_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3709 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3710,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3709],
        });
        const act_2248226175642056_closeComponent_3712 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_3711 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_3712,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_3711],
        });
        const act_1040167445267876_closeModal_3716 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_3716_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_3715 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_3716,
            event: "success",
            when: this.evh_1040167445267876_success_3715_getWhen,
            displayName: "closeModal",
        });
        const act_1040167445267876_crud_3714 = new core_1.actions.CRUDAction({
            actionArgs: this.act_1040167445267876_crud_3714_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_success_3715],
        });
        const evh_1040167445267876_submit_3713 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_crud_3714,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_3713],
        });
        const act_1419464017721962_closeComponent_3718 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_3717 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_3718,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_3717],
        });
        return {
            act_7315092382398562_closeModal_3710,
            evh_7315092382398562_close_3709,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_3712,
            evh_2248226175642056_close_3711,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_3716,
            evh_1040167445267876_success_3715,
            act_1040167445267876_crud_3714,
            evh_1040167445267876_submit_3713,
            evh_1040167445267876_submit,
            act_1419464017721962_closeComponent_3718,
            evh_1419464017721962_clickPreventStop_3717,
            evh_1419464017721962_clickPreventStop,
            save: act_1040167445267876_crud_3714,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], ContractServiceFee.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractServiceFee.prototype, "onOid", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], ContractServiceFee.prototype, "resource", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('resource'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractServiceFee.prototype, "onResource", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], ContractServiceFee.prototype, "noHeader", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('noHeader'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractServiceFee.prototype, "onNo_header", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], ContractServiceFee.prototype, "noFooter", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('noFooter'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractServiceFee.prototype, "onNo_footer", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
        default: true,
    }),
    __metadata("design:type", Boolean)
], ContractServiceFee.prototype, "displayParent", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('displayParent'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractServiceFee.prototype, "onDisplay_parent", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
        default: false,
    }),
    __metadata("design:type", Boolean)
], ContractServiceFee.prototype, "inlineCommands", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('inlineCommands'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractServiceFee.prototype, "onInline_commands", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], ContractServiceFee.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractServiceFee.prototype, "onSize", null);
ContractServiceFee = __decorate([
    (0, vue_property_decorator_1.Component)()
], ContractServiceFee);
exports.default = ContractServiceFee;
vue_property_decorator_1.Vue.component("ContractServiceFee", ContractServiceFee);
